module.exports = __webpack_public_path__ + "7b38274977f53fd5ace697a3e7e3ed56.mp3";